import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './routes/routes.jsx';
import {unregister} from './registerServiceWorker';
import getMuiTheme from 'material-ui/styles/getMuiTheme'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import configureStore from './store/configurestore.jsx';
import { Provider } from 'react-redux';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
// import './stylesheet/bootstrap.css'
import './font-awesome/css/font-awesome.min.css'
import './stylesheet/animate.css'

const muiTheme = getMuiTheme({
    stepper: {
        iconColor: 'green' ,// or logic to change color
    }
})
const store = configureStore();

// window.store = store;

ReactDOM.render(<MuiThemeProvider muiTheme={muiTheme}><Provider store={store}><Routes /></Provider></MuiThemeProvider>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js